import { useQuery } from 'react-query';
import { QueryServerKeys } from 'QueryServerKeys';
import * as InsightsService from 'services/insights';

export function useGetInsights({
  clusterName,
  startTime,
  endTime,
}: {
  clusterName: string;
  startTime: string;
  endTime: string;
}) {
  const namespace = clusterName ? `ic-${clusterName}` : '';

  const queryOptions = useQuery(
    [QueryServerKeys.OVERVIEW.FETCHING_NAMESPACE_METRICS, startTime, endTime],
    async () => {
      const res = await InsightsService.getInsights({
        namespace,
        startTime,
        endTime,
      });
      return res?.data;
    },
    {
      enabled: !!namespace && !!startTime && !!endTime,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );

  return queryOptions;
}
